/**
 * @generated SignedSource<<d11d4eb784e4bde3467eaa4105d0407c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleFooterArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"articleMoreStoriesArticle" | "helpersCheckIsPostiesArticle" | "helpersCheckIsStyleArticle" | "helpersGetArticleTypeArticle" | "morningStudioArticleFooterContent">;
  readonly " $fragmentType": "articleFooterArticle";
};
export type articleFooterArticle$key = {
  readonly " $data"?: articleFooterArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleFooterArticle">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "entityId",
    "storageKey": null
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SectionSegment",
    "kind": "LinkedField",
    "name": "sections",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "value",
        "plural": true,
        "selections": (v0/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleFooterArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleMoreStoriesArticle"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersCheckIsPostiesArticle",
      "selections": (v1/*: any*/),
      "args": null,
      "argumentDefinitions": []
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersCheckIsStyleArticle",
      "selections": (v1/*: any*/),
      "args": null,
      "argumentDefinitions": []
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersGetArticleTypeArticle",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleTypeSegment",
          "kind": "LinkedField",
          "name": "types",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ArticleType",
              "kind": "LinkedField",
              "name": "value",
              "plural": true,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "morningStudioArticleFooterContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "6d46c650394eb18b0fc5780c4dafe505";

export default node;
